import { constant, get } from 'lodash/fp';
import { createConfigurationForJob } from '../../../api/mandi';

export default cartingOptions => (
  createConfigurationForJob(get('job.id', cartingOptions))
    .then(constant(cartingOptions))
);
